import { countryData } from "@/dashboard-api-types/models/countryData.types";

const getForm = (countryOptions?: countryData[]) => ({
  formId: "country-form",
  formField: {
    country: {
      name: "locCode",
      label: "Country",
      options: [
        ...(countryOptions?.map(({ country_LocCode, country_LocName }) => ({
          value: country_LocCode,
          label: country_LocName,
        })) || []),
      ],
      errorMsg: "Required",
      errorMinMaxMsg: "",
    },
    startPeriodYear: {
      name: "startPeriodYear",
      label: "Start Period Year",
      errorMsg: "Required",
      errorMinMaxMsg: "Required",
    },
    lastPeriodYear: {
      name: "lastPeriodYear",
      label: "Last Period Year",
      options: Array.from({ length: 2049 - 1908 }, (_, i) => {
        const year = 1909 + i;
        return { value: year, label: year.toString() };
      }).reverse(),
      errorMsg: "Required",
      errorMinMaxMsg: "Only between 1909 and 2049",
    },
    periodYearStep: {
      name: "periodYearStep",
      label: "Period Year Step",
      options: Array.from({ length: 10 }, (_, i) => {
        const step = (i + 1) * 5;
        return { value: step, label: step.toString() };
      }),
      errorMsg: "Required",
      errorMinMaxMsg: "Only between 5 and 50",
    },
  },
});

export default getForm;
